module.exports = __webpack_public_path__ + "static/media/ir.ac21e9bd.svg";